import React, { useEffect, useState } from "react";
import { GenesysEnvironment, GenesysDeploymentId } from "config";

const SCRIPT_ID = "genesys-bootstrap-script";
const SCRIPT_SRC = "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js";

function ensureGenesysBootstrap(environment, deploymentId) {
  if (document.getElementById(SCRIPT_ID)) {
    return;
  }

  (function (g, e, n, es, ys) {
    g["_genesysJs"] = e;
    g[e] =
      g[e] ||
      function () {
        (g[e].q = g[e].q || []).push(arguments);
      };
    g[e].t = 1 * new Date();
    g[e].c = es;
    ys = document.createElement("script");
    ys.id = SCRIPT_ID;
    ys.async = 1;
    ys.src = n;
    ys.charset = "utf-8";
    document.head.appendChild(ys);
  })(window, "Genesys", SCRIPT_SRC, {
    environment,
    deploymentId,
  });
}

function GenesysMessenger() {
  const environment = GenesysEnvironment;
  const deploymentId = GenesysDeploymentId;

  const [ready, setReady] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!environment || !deploymentId) {
      return undefined;
    }

    ensureGenesysBootstrap(environment, deploymentId);

    const Genesys = window.Genesys;
    if (typeof Genesys !== "function") {
      return undefined;
    }

    Genesys("subscribe", "Messenger.ready", () => {
      setReady(true);
      Genesys("command", "Launcher.hide");
    });
    Genesys("subscribe", "Messenger.opened", () => setOpen(true));
    Genesys("subscribe", "Messenger.closed", () => setOpen(false));

    return undefined;
  }, [environment, deploymentId]);

  if (!environment || !deploymentId) {
    return null;
  }

  if (open) {
    return null;
  }

  const handleClick = () => {
    if (!ready || typeof window.Genesys !== "function") {
      return;
    }
    window.Genesys("command", "Messenger.open");
  };

  return (
    <button
      type="button"
      className="float float-genesys"
      aria-label="Abrir chat en línea"
      disabled={!ready}
      onClick={handleClick}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z" />
        <path d="M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z" />
      </svg>
    </button>
  );
}

export default GenesysMessenger;
